import axios from 'axios';

/** Токен ко всем запросам к нашему API — один раз, а не в каждом вызове.
 *
 *  Маршруты заказов калькулятора работали вообще без проверки входа: чужой
 *  расчёт можно было удалить или переписать, зная идентификатор, а он
 *  предсказуем — дата и время создания. Закрыть их на сервере нельзя было
 *  ровно потому, что фронтенд токен не передавал: в разных местах вызовы
 *  писались то с заголовком, то без, и добавлять его в одиннадцати файлах
 *  значило бы забыть в двенадцатом.
 *
 *  Публичные разделы трогать нельзя: страница оферты для клиента дилера и
 *  встроенный калькулятор на сайте работают без входа вовсе.
 */
const PUBLIC_PREFIXES = ['/api/public/', '/api/widget/'];

// У дилерского портала свой токен и свой перехватчик — его заголовок не
// переписываем, иначе дилер пойдёт в API под правами сотрудника.
const FOREIGN_PREFIXES = ['/api/dealer/'];

const isOurApi = (url) => {
  const path = String(url || '');
  if (!path.includes('/api/')) return false;
  const rest = path.slice(path.indexOf('/api/'));
  if (PUBLIC_PREFIXES.some((p) => rest.startsWith(p))) return false;
  if (FOREIGN_PREFIXES.some((p) => rest.startsWith(p))) return false;
  return true;
};

export const installAuthInterceptor = () => {
  axios.interceptors.request.use((config) => {
    const already = config.headers?.Authorization || config.headers?.authorization;
    if (already || !isOurApi(config.url)) return config;
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
    }
    return config;
  });
};

export default installAuthInterceptor;
